<template>
	<heading />
	<content class="">
		<div class="row">
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="row d-none">
						<div class="col-12 float-sm-left text-start">
							<h4 class="m-0 text-dark" style="font-family: NunitoBlack">
								<font-awesome-icon class="nav-icon" :icon="['fas', 'cogs']" />
								Operations Masters&nbsp;&nbsp;
							</h4>
						</div>
					</div>

					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i class="nav-icon fas fa-cogs"></i
												>&nbsp;&nbsp;Masters&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">
										&nbsp;&nbsp;Operations Masters&nbsp;&nbsp;
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 pt-0">
					<!-- selected-class="bg-blue-custom text-white" -->
					<v-card>
						<v-tabs
							v-model="activeTab"
							density="compact"
							align-tabs="center"
							class="nunito-black"
						>
							<v-tab :value="1">Lodges</v-tab>
							<v-tab :value="2">Meals</v-tab>
							<v-tab :value="3">Boats</v-tab>
							<v-tab :value="4">Flights</v-tab>
							<v-tab :value="5">Vehicles</v-tab>
						</v-tabs>

						<v-window v-model="activeTab">
							<v-window-item :value="1">
								<div class="card card-body accordion-body text-dark">
									<div class="row col-sm-12">
										<div class="col-sm-7 float-sm-left text-start"></div>
										<div
											class="col-sm-5 text-end"
											style="font-family: HeaderCustomFont"
										>
											<button
												class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
												@click="openModal('accommodation')"
											>
												<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add
												Accommodation
											</button>
										</div>
									</div>
									<div class="row col-sm-12 mt-2 m-1">
										<v-data-table
											:headers="accommodationHeaders"
											:items="accommodationsComputed"
											:items-per-page="accommodationPerPage"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													class="align-top"
													v-for="(item, index) in items"
													:key="item.id"
												>
													<td>{{ item.index }}</td>
													<td>{{ item.name }}</td>
													<td>{{ item.supplier_id }}</td>
													<td>{{ item.email }}</td>
													<td>{{ item.district_code }}</td>
													<td>{{ item.town_id }}</td>
													<td class="">
														<v-menu offset-y>
															<template v-slot:activator="{ props }">
																<v-icon v-bind="props" size="24">
																	mdi-dots-horizontal
																</v-icon>
															</template>

															<v-list density="compact" class="custom-dropdown">
																<v-list-item
																	@click="manageAccommodations(item, 'edit')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-regular fa-pen-to-square"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																	>
																</v-list-item>
																<v-list-item
																	@click="manageAccommodations(item, 'delete')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-solid fa-trash"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																	>
																</v-list-item>
															</v-list>
														</v-menu>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</v-window-item>

							<v-window-item :value="2">
								<div class="card card-body accordion-body text-dark">
									<div class="row col-sm-12">
										<div class="col-sm-7 float-sm-left text-start"></div>
										<div
											class="col-sm-5 text-end"
											style="font-family: HeaderCustomFont"
										>
											<button
												class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
												@click="openModal('meal')"
											>
												<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add Meal
											</button>
										</div>
									</div>
									<div class="row col-sm-12 mt-2 m-1">
										<v-data-table
											:headers="mealHeaders"
											:items="mealsComputed"
											:items-per-page="mealPerPage"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													class="align-top"
													v-for="(item, index) in items"
													:key="item.id"
												>
													<td>{{ item.index }}</td>
													<td>{{ item.name }}</td>
													<td>{{ item.code }}</td>
													<td class="">
														<v-menu offset-y>
															<template v-slot:activator="{ props }">
																<v-icon v-bind="props" size="24">
																	mdi-dots-horizontal
																</v-icon>
															</template>

															<v-list density="compact" class="custom-dropdown">
																<v-list-item @click="manageMeals(item, 'edit')">
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-regular fa-pen-to-square"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																	>
																</v-list-item>
																<v-list-item
																	@click="manageMeals(item, 'delete')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-solid fa-trash"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																	>
																</v-list-item>
															</v-list>
														</v-menu>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</v-window-item>

							<v-window-item :value="3">
								<div class="card card-body accordion-body text-dark">
									<div class="row col-sm-12">
										<div class="col-sm-7 float-sm-left text-start"></div>
										<div
											class="col-sm-5 text-end"
											style="font-family: HeaderCustomFont"
										>
											<button
												class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
												@click="openModal('boat')"
											>
												<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add Boat
											</button>
										</div>
									</div>
									<div class="row col-sm-12 mt-2 m-1">
										<v-data-table
											:headers="boatHeaders"
											:items="boatsComputed"
											:items-per-page="boatPerPage"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													class="align-top"
													v-for="(item, index) in items"
													:key="item.id"
												>
													<td>{{ item.index }}</td>
													<td>{{ item.name }}</td>
													<td>{{ item.supplier_id }}</td>
													<td class="">
														<v-menu offset-y>
															<template v-slot:activator="{ props }">
																<v-icon v-bind="props" size="24">
																	mdi-dots-horizontal
																</v-icon>
															</template>

															<v-list density="compact" class="custom-dropdown">
																<v-list-item @click="manageBoats(item, 'edit')">
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-regular fa-pen-to-square"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																	>
																</v-list-item>
																<v-list-item
																	@click="manageBoats(item, 'delete')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-solid fa-trash"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																	>
																</v-list-item>
															</v-list>
														</v-menu>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</v-window-item>

							<v-window-item :value="4">
								<div class="card card-body accordion-body text-dark">
									<div class="row col-sm-12">
										<div class="col-sm-7 float-sm-left text-start"></div>
										<div
											class="col-sm-5 text-end"
											style="font-family: HeaderCustomFont"
										>
											<button
												class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
												@click="openModal('flight')"
											>
												<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add
												Flight
											</button>
										</div>
									</div>
									<div class="row col-sm-12 mt-2 m-1">
										<v-data-table
											:headers="flightHeaders"
											:items="flightsComputed"
											:items-per-page="flightPerPage"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													class="align-top"
													v-for="(item, index) in items"
													:key="item.id"
												>
													<td>{{ item.index }}</td>
													<td>{{ item.name }}</td>
													<td>{{ item.supplier_id }}</td>
													<td>{{ item.inclusions }}</td>
													<td class="">
														<v-menu offset-y>
															<template v-slot:activator="{ props }">
																<v-icon v-bind="props" size="24">
																	mdi-dots-horizontal
																</v-icon>
															</template>

															<v-list density="compact" class="custom-dropdown">
																<v-list-item
																	@click="manageFlights(item, 'edit')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-regular fa-pen-to-square"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																	>
																</v-list-item>
																<v-list-item
																	@click="manageFlights(item, 'delete')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-solid fa-trash"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																	>
																</v-list-item>
															</v-list>
														</v-menu>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</v-window-item>

							<v-window-item :value="5">
								<div class="card card-body accordion-body text-dark">
									<div class="row col-sm-12">
										<div class="col-sm-7 float-sm-left text-start"></div>
										<div
											class="col-sm-5 text-end"
											style="font-family: HeaderCustomFont"
										>
											<button
												class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
												@click="openModal('vehicle')"
											>
												<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add
												Vehicle
											</button>
										</div>
									</div>
									<div class="row col-sm-12 mt-2 m-1">
										<v-data-table
											:headers="vehicleHeaders"
											:items="vehiclesComputed"
											:items-per-page="vehiclePerPage"
											density="compact"
											item-value="plate_number"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													class="align-top"
													v-for="(item, index) in items"
													:key="item.id"
												>
													<td>{{ item.index }}</td>
													<td>{{ item.plate_number }}</td>
													<td>{{ item.company }}</td>
													<td>{{ item.is_hired }}</td>
													<td>{{ item.mileage }}</td>
													<td>{{ item.next_service }}</td>
													<td class="">
														<v-menu offset-y>
															<template v-slot:activator="{ props }">
																<v-icon v-bind="props" size="24">
																	mdi-dots-horizontal
																</v-icon>
															</template>

															<v-list density="compact" class="custom-dropdown">
																<v-list-item
																	@click="manageVehicles(item, 'edit')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-regular fa-pen-to-square"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																	>
																</v-list-item>
																<v-list-item
																	@click="manageVehicles(item, 'delete')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-solid fa-trash"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																	>
																</v-list-item>
															</v-list>
														</v-menu>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</v-window-item>
						</v-window>
					</v-card>
				</div>
			</div>

			<!-- Accommodation Modal -->
			<v-dialog v-model="accommodationModal" max-width="600px" persistent>
				<form
					@submit.prevent="
						editMode
							? manageAccommodations(null, 'update')
							: manageAccommodations(null, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;{{
											editMode ? "Edit" : "Add"
										}}
										Accommodation
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('accommodation')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start"></div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save
										Accommodation
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('accommodation')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>

			<!-- Meal Modal -->
			<v-dialog v-model="mealModal" max-width="600px" persistent>
				<form
					@submit.prevent="
						editMode ? manageMeals(null, 'update') : manageMeals(null, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;{{
											editMode ? "Edit" : "Add"
										}}
										Meal
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('meal')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start"></div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Meal
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('meal')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>

			<!-- Boat Modal -->
			<v-dialog v-model="boatModal" max-width="600px" persistent>
				<form
					@submit.prevent="
						editMode ? manageBoats(null, 'update') : manageBoats(null, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;{{
											editMode ? "Edit" : "Add"
										}}
										Boat
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('boat')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start"></div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Boat
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('boat')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>

			<!-- Flight Modal -->
			<v-dialog v-model="flightModal" max-width="600px" persistent>
				<form
					@submit.prevent="
						editMode
							? manageFlights(null, 'update')
							: manageFlights(null, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;{{
											editMode ? "Edit" : "Add"
										}}
										Flight
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('flight')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start"></div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Flight
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('flight')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>

			<!-- Vehicle Modal -->
			<v-dialog v-model="vehicleModal" max-width="600px" persistent>
				<form
					@submit.prevent="
						editMode
							? manageVehicles(null, 'update')
							: manageVehicles(null, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;{{
											editMode ? "Edit" : "Add"
										}}
										Vehicle
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('vehicle')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start"></div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Vehicle
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('vehicle')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>
		</div>
	</content>
</template>

<script>
import config from "../../config/settings.js";
import { Errors, Form } from "vform";

export default {
	name: "OperationsMaster",
	data() {
		return {
			api: config.API_URL,
			prefix: config.API_PFX,
			message: "",
			http_code: "",
			user: [],
			activeTab: 1,

			accommodationModal: false,
			mealModal: false,
			boatModal: false,
			flightModal: false,
			vehicleModal: false,
			editMode: false,
			accommodationForm: new Form({
				id: "",
				name: "",
				supplier_id: "",
				email: "",
				inclusions: "",
				district_code: "",
				town_id: "",
			}),
			mealForm: new Form({
				id: "",
				name: "",
				code: "",
			}),
			boatForm: new Form({
				id: "",
				name: "",
				supplier_id: "",
			}),
			flightForm: new Form({
				id: "",
				name: "",
				supplier_id: "",
				inclusions: "",
			}),
			vehicleForm: new Form({
				id: "",
				plate_number: "",
				company: "",
				is_hired: "",
				mileage: "",
				next_service: "",
			}),
			accommodations: [],
			meals: [],
			boats: [],
			flights: [],
			vehicles: [],
			accommodationPerPage: 10,
			mealPerPage: 10,
			boatPerPage: 10,
			flightPerPage: 10,
			vehiclePerPage: 10,
			accommodationHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Name", value: "name", sortable: true },
				{ title: "Supplier ID", value: "supplier_id", sortable: true },
				{ title: "Email", value: "email", sortable: true },
				{ title: "District Code", value: "district_code", sortable: true },
				{ title: "Town ID", value: "town_id", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			mealHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Name", value: "name", sortable: true },
				{ title: "Code", value: "code", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			boatHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Name", value: "name", sortable: true },
				{ title: "Supplier ID", value: "supplier_id", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			flightHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Name", value: "name", sortable: true },
				{ title: "Supplier ID", value: "supplier_id", sortable: true },
				{ title: "Inclusions", value: "inclusions", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			vehicleHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Plate Number", value: "plate_number", sortable: true },
				{ title: "Company", value: "company", sortable: true },
				{ title: "Is Hired", value: "is_hired", sortable: true },
				{ title: "Mileage", value: "mileage", sortable: true },
				{ title: "Next Service", value: "next_service", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
		};
	},
	methods: {
		async getUser() {
			var user_id = localStorage.getItem("user_id");
			if (user_id) {
				var api = this.api + "/user/" + user_id;
				const query = await this.getData(api);
				if (query.result == "success") {
					this.user = query.data;
				}
			}
		},
		openModal(modal) {
			this.editMode = false;
			if (modal == "accommodation") {
				this.accommodationModal = true;
				this.accommodationForm.reset();
			} else if (modal == "meal") {
				this.mealModal = true;
				this.mealForm.reset();
			} else if (modal == "boat") {
				this.boatModal = true;
				this.boatForm.reset();
			} else if (modal == "flight") {
				this.flightModal = true;
				this.flightForm.reset();
			} else if (modal == "vehicle") {
				this.vehicleModal = true;
				this.vehicleForm.reset();
			}
		},
		closeModal(modal) {
			if (modal == "accommodation") {
				this.accommodationModal = false;
				this.accommodationForm.reset();
				this.accommodationForm.errors.clear();
			} else if (modal == "meal") {
				this.mealModal = false;
				this.mealForm.reset();
				this.mealForm.errors.clear();
			} else if (modal == "boat") {
				this.boatModal = false;
				this.boatForm.reset();
				this.boatForm.errors.clear();
			} else if (modal == "flight") {
				this.flightModal = false;
				this.flightForm.reset();
				this.flightForm.errors.clear();
			} else if (modal == "vehicle") {
				this.vehicleModal = false;
				this.vehicleForm.reset();
				this.vehicleForm.errors.clear();
			}
			this.editMode = false;
		},
		async getInfinites(mode) {
			var query, api;
			if (mode == "accommodations") {
				api = this.api + this.prefix + "/operations/accommodations";
				query = await this.getData(api);
				if (query.result == "success") {
					this.accommodations = query.data;
				}
			} else if (mode == "meals") {
				api = this.api + this.prefix + "/operations/meals";
				query = await this.getData(api);
				if (query.result == "success") {
					this.meals = query.data;
				}
			} else if (mode == "boats") {
				api = this.api + this.prefix + "/operations/boats";
				query = await this.getData(api);
				if (query.result == "success") {
					this.boats = query.data;
				}
			} else if (mode == "flights") {
				api = this.api + this.prefix + "/operations/flights";
				query = await this.getData(api);
				if (query.result == "success") {
					this.flights = query.data;
				}
			} else if (mode == "vehicles") {
				api = this.api + this.prefix + "/operations/vehicles";
				query = await this.getData(api);
				if (query.result == "success") {
					this.vehicles = query.data;
				}
			}
		},
		async manageAccommodations(event, mode) {
			var query, api;
			if (mode == "fetch") {
				await this.getInfinites("accommodations");
			} else if (mode == "insert") {
				this.accommodationForm.created_by = this.user.id;
				api = this.api + this.prefix + "/operations/accommodations";
				query = await this.postData(api, this.accommodationForm);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.closeModal("accommodation");
					this.manageAccommodations(null, "fetch");
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
				}
			} else if (mode == "update") {
				this.accommodationForm.updated_by = this.user.id;
				api =
					this.api +
					this.prefix +
					"/operations/accommodations/" +
					this.accommodationForm.id;
				query = await this.putData(api, this.accommodationForm);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.closeModal("accommodation");
					this.manageAccommodations(null, "fetch");
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
				}
			} else if (mode == "edit") {
				this.accommodationForm.reset();
				this.accommodationForm.fill(event);
				this.editMode = true;
				this.openModal("accommodation");
			} else if (mode == "delete") {
				let confirmation = await this.showConfirmation(
					"Delete this Accommodation?"
				);
				if (confirmation.result == "Yes") {
					api =
						this.api + this.prefix + "/operations/accommodations/" + event.id;
					query = await this.deleteData(api);
					if (query.result == "success") {
						this.message = query.response.message;
						this.http_code = query.code;
						this.manageAccommodations(null, "fetch");
					} else {
						this.message = query.response.message;
						this.http_code = query.code;
					}
				}
			}
		},
		async manageMeals(event, mode) {
			var query, api;
			if (mode == "fetch") {
				await this.getInfinites("meals");
			} else if (mode == "insert") {
				this.mealForm.created_by = this.user.id;
				api = this.api + this.prefix + "/operations/meals";
				query = await this.postData(api, this.mealForm);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.closeModal("meal");
					this.manageMeals(null, "fetch");
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
				}
			} else if (mode == "update") {
				this.mealForm.updated_by = this.user.id;
				api = this.api + this.prefix + "/operations/meals/" + this.mealForm.id;
				query = await this.putData(api, this.mealForm);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.closeModal("meal");
					this.manageMeals(null, "fetch");
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
				}
			} else if (mode == "edit") {
				this.mealForm.reset();
				this.mealForm.fill(event);
				this.editMode = true;
				this.openModal("meal");
			} else if (mode == "delete") {
				let confirmation = await this.showConfirmation("Delete this Meal?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/operations/meals/" + event.id;
					query = await this.deleteData(api);
					if (query.result == "success") {
						this.message = query.response.message;
						this.http_code = query.code;
						this.manageMeals(null, "fetch");
					} else {
						this.message = query.response.message;
						this.http_code = query.code;
					}
				}
			}
		},
		async manageBoats(event, mode) {
			var query, api;
			if (mode == "fetch") {
				await this.getInfinites("boats");
			} else if (mode == "insert") {
				this.boatForm.created_by = this.user.id;
				api = this.api + this.prefix + "/operations/boats";
				query = await this.postData(api, this.boatForm);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.closeModal("boat");
					this.manageBoats(null, "fetch");
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
				}
			} else if (mode == "update") {
				this.boatForm.updated_by = this.user.id;
				api = this.api + this.prefix + "/operations/boats/" + this.boatForm.id;
				query = await this.putData(api, this.boatForm);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.closeModal("boat");
					this.manageBoats(null, "fetch");
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
				}
			} else if (mode == "edit") {
				this.boatForm.reset();
				this.boatForm.fill(event);
				this.editMode = true;
				this.openModal("boat");
			} else if (mode == "delete") {
				let confirmation = await this.showConfirmation("Delete this Boat?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/operations/boats/" + event.id;
					query = await this.deleteData(api);
					if (query.result == "success") {
						this.message = query.response.message;
						this.http_code = query.code;
						this.manageBoats(null, "fetch");
					} else {
						this.message = query.response.message;
						this.http_code = query.code;
					}
				}
			}
		},
		async manageFlights(event, mode) {
			var query, api;
			if (mode == "fetch") {
				await this.getInfinites("flights");
			} else if (mode == "insert") {
				this.flightForm.created_by = this.user.id;
				api = this.api + this.prefix + "/operations/flights";
				query = await this.postData(api, this.flightForm);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.closeModal("flight");
					this.manageFlights(null, "fetch");
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
				}
			} else if (mode == "update") {
				this.flightForm.updated_by = this.user.id;
				api =
					this.api + this.prefix + "/operations/flights/" + this.flightForm.id;
				query = await this.putData(api, this.flightForm);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.closeModal("flight");
					this.manageFlights(null, "fetch");
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
				}
			} else if (mode == "edit") {
				this.flightForm.reset();
				this.flightForm.fill(event);
				this.editMode = true;
				this.openModal("flight");
			} else if (mode == "delete") {
				let confirmation = await this.showConfirmation("Delete this Flight?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/operations/flights/" + event.id;
					query = await this.deleteData(api);
					if (query.result == "success") {
						this.message = query.response.message;
						this.http_code = query.code;
						this.manageFlights(null, "fetch");
					} else {
						this.message = query.response.message;
						this.http_code = query.code;
					}
				}
			}
		},
		async manageVehicles(event, mode) {
			var query, api;
			if (mode == "fetch") {
				await this.getInfinites("vehicles");
			} else if (mode == "insert") {
				this.vehicleForm.created_by = this.user.id;
				api = this.api + this.prefix + "/operations/vehicles";
				query = await this.postData(api, this.vehicleForm);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.closeModal("vehicle");
					this.manageVehicles(null, "fetch");
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
				}
			} else if (mode == "update") {
				this.vehicleForm.updated_by = this.user.id;
				api =
					this.api +
					this.prefix +
					"/operations/vehicles/" +
					this.vehicleForm.id;
				query = await this.putData(api, this.vehicleForm);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.closeModal("vehicle");
					this.manageVehicles(null, "fetch");
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
				}
			} else if (mode == "edit") {
				this.vehicleForm.reset();
				this.vehicleForm.fill(event);
				this.editMode = true;
				this.openModal("vehicle");
			} else if (mode == "delete") {
				let confirmation = await this.showConfirmation("Delete this Vehicle?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/operations/vehicles/" + event.id;
					query = await this.deleteData(api);
					if (query.result == "success") {
						this.message = query.response.message;
						this.http_code = query.code;
						this.manageVehicles(null, "fetch");
					} else {
						this.message = query.response.message;
						this.http_code = query.code;
					}
				}
			}
		},
	},
	computed: {
		currentRoute() {
			return this.$route.path.includes("/masters/");
		},
		accommodationsComputed() {
			if (!Array.isArray(this.accommodations)) return [];
			return this.accommodations.map((accommodation, index) => {
				accommodation.index = index + 1;
				return accommodation;
			});
		},
		mealsComputed() {
			if (!Array.isArray(this.meals)) return [];
			return this.meals.map((meal, index) => {
				meal.index = index + 1;
				return meal;
			});
		},
		boatsComputed() {
			if (!Array.isArray(this.boats)) return [];
			return this.boats.map((boat, index) => {
				boat.index = index + 1;
				return boat;
			});
		},
		flightsComputed() {
			if (!Array.isArray(this.flights)) return [];
			return this.flights.map((flight, index) => {
				flight.index = index + 1;
				return flight;
			});
		},
		vehiclesComputed() {
			if (!Array.isArray(this.vehicles)) return [];
			return this.vehicles.map((vehicle, index) => {
				vehicle.index = index + 1;
				return vehicle;
			});
		},
	},
	created() {
		this.getUser();
		this.manageAccommodations(null, "fetch");
		this.manageMeals(null, "fetch");
		this.manageBoats(null, "fetch");
		this.manageFlights(null, "fetch");
		this.manageVehicles(null, "fetch");
	},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {},
};
</script>